import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const SubProcessorsPage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/sub-processors.md"
      title="Sub-Processors"
      description="Third-party companies that process personal data on behalf of admeru."
    />
  );
};
